module.exports = __webpack_public_path__ + "img/code.32172e37.png";